import type { Headline, Story } from '@/types/database'

/**
 * Your feed's own types (migration 20240034_feed.sql). Kept here rather than in
 * types/database.ts so the feed can be ported alongside the other screens.
 */

/** A headline as the feed card reads it. */
export interface FeedHeadline extends Headline {
  /** How many outlets carry it ("4 sources"). Null: not known; a record is its own source. */
  source_count?: number | null
  /** "Your angle": one line for this creator. */
  angle?: string | null
  /** 'morning': the day's free five. 'more': Pull 5 more. */
  pull?: 'morning' | 'more' | null
}

export type BuildStage = 'queued' | 'reading' | 'verifying' | 'crafting' | 'tone' | 'harvesting'

/** A story built from a feed headline. status 'developing' while Emma writes it. */
export type FeedStory = Pick<Story,
  'id' | 'headline_id' | 'status' | 'headline' | 'category' | 'created_at' | 'updated_at'
  | 'article' | 'script' | 'caption' | 'voice' | 'source_name' | 'source_url' | 'image_url'
> & { build_stage?: BuildStage | null }

export interface FeedNudge {
  kind: 'topic' | 'source'
  key: string
  label: string
  n: number
}

export interface FeedData {
  /** Every headline dealt in the last seven days, oldest first. */
  headlines: FeedHeadline[]
  /** This person's decisions: 'left' is Not interested, 'right' is Build. */
  decided: Map<string, 'left' | 'right'>
  /** Stories built from these headlines, by headline id. */
  stories: Map<string, FeedStory>
}

/** Where each real build stage sits on the Writing bar. */
export const STAGE_PCT: Record<BuildStage, number> = {
  queued: 3, reading: 10, verifying: 24, crafting: 46, tone: 74, harvesting: 90,
}
